import i18n from 'i18next';
import axios, { superAxios } from '../../../shared/utils/axios';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';
import { serializeQuerystring } from '../../../shared/utils/object';
import { actionSuccess } from '../utils';

export const FETCH_COMPANY = 'FETCH_COMPANY';
export const FETCH_COMPANY_WITHDRAWALS_PAGINATED = 'FETCH_COMPANY_WITHDRAWALS_PAGINATED';
export const FETCH_COMPANY_INSIGHTS = 'FETCH_COMPANY_INSIGHTS';
export const CLEAR_CURRENT_COMPANY_DATA = 'CLEAR_CURRENT_COMPANY_DATA';
export const PUT_COMPANY_SETTINGS = 'PUT_COMPANY_SETTINGS';

const companyEndpoint = `${process.env.REACT_APP_API_URL}dashboards/company`;

export const getQueryStringForWithdrawals = (filters = {}) => {
  let filterString = serializeQuerystring({
    searchTerm: filters.searchTerm || '',
    startDate: filters.startDate,
    endDate: filters.endDate
  });

  if (filters.currentFilters) filterString += filters.currentFilters;

  return `offset=${filters?.offset || 0}&limit=${filters?.rowsPerPage || 15}${filterString}`;
};
const companyWithdrawalsEndpointPaged = filters => {
  const queryString = getQueryStringForWithdrawals(filters);

  return `${process.env.REACT_APP_API_URL}company/withdrawals?${queryString}`;
};

const companyInsightsEndpoint = `${process.env.REACT_APP_API_URL}dashboard-insights`;
const superAdminCompanyEndpoint = companyId => `${process.env.REACT_APP_API_URL}super/company/${companyId}`;
const changePasswordEndpoint = `${process.env.REACT_APP_ZEUS_API_URL}/dashboard/admin/password`;

export const clearCurrentCompanyData = () => ({
  type: CLEAR_CURRENT_COMPANY_DATA
});

export const fetchCompanyWithdrawalsPaginated =
  (filters = {}) =>
  async dispatch => {
    try {
      const response = await axios.get(companyWithdrawalsEndpointPaged(filters));
      dispatch(actionSuccess(FETCH_COMPANY_WITHDRAWALS_PAGINATED, response?.data));

      return response?.data?.data;
    } catch (error) {
      dispatch(addToast(toastTypes.error, error));
    }
  };

export const fetchCompanyInsights = () => async dispatch => {
  try {
    const response = await axios.get(companyInsightsEndpoint);
    dispatch(actionSuccess(FETCH_COMPANY_INSIGHTS, response?.data));

    return response?.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const putCompanySettings = settings => async dispatch => {
  try {
    const response = await axios.put(companyEndpoint, settings);

    dispatch(actionSuccess(PUT_COMPANY_SETTINGS, response?.data));

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: i18n.t('company.putCompanySettings.success', {
          ns: 'actions'
        })
      })
    );

    dispatch(fetchCompany());
    return response?.data?.data;
  } catch (error) {
    dispatch(
      addToast(
        {
          ...toastTypes.error,
          defaultMessage: i18n.t('company.putCompanySettings.error', {
            ns: 'actions'
          })
        },
        error
      )
    );
  }
};

export const putCompanyImage =
  (image, companyId, contentType = 'multipart/form-data') =>
  async dispatch => {
    try {
      await superAxios.put(superAdminCompanyEndpoint(companyId), image, {
        headers: {
          'Content-type': contentType
        },
        withCredentials: true,
        timeout: 30000
      });
      dispatch(
        addToast({
          ...toastTypes.success,
          defaultMessage: i18n.t('company.putCompany.success', {
            ns: 'actions'
          })
        })
      );

      return true;
    } catch (error) {
      dispatch(
        addToast(
          {
            ...toastTypes.error,
            defaultMessage: i18n.t('company.putCompany.error', {
              ns: 'actions'
            })
          },
          error
        )
      );

      return undefined;
    }
  };

export const fetchCompany = () => async dispatch => {
  try {
    const response = await axios.get(companyEndpoint);
    dispatch(actionSuccess(FETCH_COMPANY, response.data));

    return response.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const changePassword = (payload, onSuccessCallback) => async dispatch => {
  try {
    await axios.put(changePasswordEndpoint, payload);

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: i18n.t('company.putPassword.success', {
          ns: ['actions']
        })
      })
    );
    onSuccessCallback();
  } catch (error) {
    if (error.response.data.message === 'New password matches a previously used password') {
      dispatch(
        addToast(
          {
            ...toastTypes.error,
            defaultMessage: i18n.t('company.putPassword.non repeated password', {
              ns: ['actions']
            })
          },
          error
        )
      );
      return;
    }

    if (error.response.data.message === 'Your password was updated recently. Try again in 24 hours.') {
      dispatch(
        addToast(
          {
            ...toastTypes.error,
            defaultMessage: i18n.t('company.putPassword.recent password update', {
              ns: ['actions']
            })
          },
          error
        )
      );
      return;
    }

    dispatch(
      addToast(
        {
          ...toastTypes.error,
          defaultMessage: i18n.t('company.putPassword.error', {
            ns: ['actions']
          })
        },
        error
      )
    );
  }
};
